/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
import Vue from 'vue'
import sharedState from '../shared/state'
import moment from 'moment'
import { date } from 'quasar'

export default {
  setLoading,
  setList,
  setJobModalOpen,
  setCurrentJob,
  setDraftStudentsLoading,
  setDraftStudents,
  setDraftStudentModalOpen,
  clearSearchFields,
}

function setLoading(state, loading) {
  state.loading = loading
}

function setList(state, { jobs }) {
  state.list = jobs
}

function setJobModalOpen(state, payload) {
  state.jobModalOpen = payload
}

function setCurrentJob(state, payload) {
  state.currentJob = payload
}

function setDraftStudentsLoading(state, payload) {
  state.draftStudentsLoading = payload
}

function transformDraftStudents(students) {
  function formatDate(d) {
    return d ? moment(d).utc().format('MM/DD/YYYY') : ""
  }

  return students.map(s => ({
    ...s,
    COMPLETION_DATE: formatDate(s.COMPLETION_DATE),
    DOB: formatDate(s.DOB),
  }))
}

function setDraftStudents(state, payload) {
  if (Array.isArray(payload)) {
    state.draftStudents = transformDraftStudents(payload)
  } else {
    state.draftStudents = []
  }
}

function setDraftStudentModalOpen(state, payload) {
  state.draftStudentModalOpen = payload
}

function clearSearchFields(state, payload){
  state.searchFields = _.cloneDeep(initialState.searchFields)
}